var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('PrintView'),_c('ScrollTop'),_c('div',{class:{ 'd-none': _vm.printView }},[_c('Header'),_c('router-view'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }